import Button from 'components/button/Button';
import { Trans } from 'react-i18next';
import { HostfullyLinkContainer } from './IntegrationCell.styles';

interface Props {
  label: string;
  onAccess: () => void;
  isFetching?: boolean;
}

/**
 * Access link for products whose access URL expires shortly after the BE
 * creates it, so it is requested on click instead of rendered as an anchor.
 */
const AsyncAccessLink = ({ label, onAccess, isFetching }: Props) => (
  <HostfullyLinkContainer>
    <Button
      bsStyle="link"
      disabled={isFetching}
      onClick={(event) => {
        event.stopPropagation();
        onAccess();
      }}
      aria-label="Access link"
      data-testid="access-link-hostfully-integration"
    >
      <Trans
        i18nKey="pageIntegrations.table.accessLink"
        values={{ label }}
        components={{ 1: <span /> }}
      />
    </Button>
  </HostfullyLinkContainer>
);

export default AsyncAccessLink;
